import { actionTypes } from './constants';
export var inputChange = function (dispatch, validate) {
    return function (id, validation) {
        var _a;
        return dispatch({ type: actionTypes.INPUT_CHANGE, payload: (_a = {}, _a[id] = validation, _a), validate: validate });
    };
};
export var showValidation = function (dispatch) {
    return function (show) {
        return dispatch({ type: actionTypes.SHOW_VALIDATION, payload: show });
    };
};
export var enableFormSubmit = function (dispatch) { return function () {
    return dispatch({ type: actionTypes.PREVENT_SUBMIT, payload: false });
}; };
export var preventFormSubmit = function (dispatch) { return function () {
    return dispatch({ type: actionTypes.PREVENT_SUBMIT, payload: true });
}; };
